/**
 * Menu Setting Endpoints
 * SUPERADMIN: Menu and submenu management APIs
 */

export const MENU_SETTING_ENDPOINTS = {
    //   listAllMenuSubmenu: 'menu/list-all-menu-submenu',
    updateMenuAccess: 'menu/assign-program-menus-to-user',
    listAllMenuSubmenu: 'menu/list-user-menus',

};
